<h3 i18n>Amount</h3>
<p>{{ transaction.amount | currency: transaction.currency.code }}</p>

<ng-container *ngIf="!transaction.isCanceled">
    <form>
        <mat-form-field>
            <mat-label i18n>Please choose your method of payment</mat-label>
            <mat-select [formControl]="availablePaymentMethodsControl"
                        (selectionChange)="onSelectValueChange($event)">
                <mat-option value="" disabled selected i18n>Select payment method...</mat-option>
                <mat-option *ngFor="let method of availablePaymentMethods"
                            [value]="method.id">{{ method.displayName ?? method.doc._id }}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
    <ub-button-list>
        <button mat-flat-button
                color="primary"
                type="button"
                (click)="onClicked()"
                [disabled]="isOperationInProgress || availablePaymentMethodsControl.invalid" i18n>Continue to payment</button>
    </ub-button-list>
</ng-container>
